import {
  Children,
  cloneElement,
  isValidElement,
  type ReactElement,
  type ReactNode,
} from "react";
import { cn } from "@/lib/cn";

/**
 * Slot minimal (estilo Radix): fusiona sus props/className en el ÚNICO hijo
 * en vez de renderizar un wrapper. Sirve para `asChild` — ej. un Button que
 * en realidad renderiza un <Link> conservando los estilos del botón.
 */
export function Slot({
  children,
  className,
  ...props
}: {
  children?: ReactNode;
  className?: string;
} & Record<string, unknown>) {
  const child = Children.only(children) as ReactElement<{
    className?: string;
  }>;
  if (!isValidElement(child)) return null;
  return cloneElement(child, {
    ...props,
    className: cn(className, child.props?.className),
  } as Record<string, unknown>);
}
